import GoodsItemEdit from './goodsItemEdit'
import { Wrapper, GoodsGrid, StickyHeaderSlot, ScrollHeaderBlock, BelowStickyBlock } from '../goods/goodsList';

export default function ModalEditGoodsList({editGoods , editGoodsDefault, productEditList,
                                            setProdactEditList, setEditGoods, productNonOrder,
                                            getMlai, getMhir, showDetailes, setDataForDetailes,
                                            setProductNonOrder,disabelSave, packegeList,
                                            isEditArizot, getGoodPrice, date, stickyHeader, scrollHeader, belowSticky,
                                        }) {


    return(
        <Wrapper>
            {scrollHeader ? <ScrollHeaderBlock>{scrollHeader}</ScrollHeaderBlock> : null}
            {stickyHeader ? <StickyHeaderSlot>{stickyHeader}</StickyHeaderSlot> : null}
            {belowSticky ? <BelowStickyBlock>{belowSticky}</BelowStickyBlock> : null}
            <GoodsGrid>
                {editGoods.map(item => <GoodsItemEdit key={item.id} {...item}
                    setProductNonOrder={setProductNonOrder}
                    productEditList={productEditList}
                    setProdactEditList={setProdactEditList}
                    setEditGoods={setEditGoods}
                    productNonOrder={productNonOrder}
                    packegeList={packegeList}
                    disabelSave={disabelSave}
                    getMlai={getMlai}
                    getMhir={getMhir}
                    showDetailes={showDetailes}
                    setDataForDetailes={setDataForDetailes}
                    isEditArizot={isEditArizot}
                    item={item}
                    getGoodPrice={getGoodPrice}
                    date={date}
                    />)}
            </GoodsGrid>
        </Wrapper>

    );
}